import { Box, Container, Typography, Grid, CardMedia, Paper } from '@mui/material';

const AboutUsPage = () => {
  return (
    <Box sx={{ py: 8 }}>
      <Container maxWidth="lg">
        <Typography 
          variant="h2" 
          component="h1" 
          align="center" 
          gutterBottom
          sx={{ 
            fontWeight: 700, 
            mb: 4,
            fontSize: { xs: '2rem', md: '2.5rem' }
          }}
        >
          About Us
        </Typography>
        
        <Typography 
          variant="subtitle1" 
          align="justify" 
          sx={{ whiteSpace: 'pre-line', mb: 4, maxWidth: '800px', mx: 'auto' }}
        >
          At Recruitment Intelligence, we're not just another recruiting platform. We're a team of passionate innovators who believe that hiring should be smarter, faster, and more effective. Our mission is to transform the way companies find and hire talent by combining cutting-edge AI technology with deep industry expertise.
        </Typography>


        <Box sx={{ mb: 4, maxWidth: '800px', mx: 'auto' }}>
          <Paper 
            elevation={3} 
            sx={{ 
              overflow: 'hidden',
              borderRadius: 2,
            }}
          >
            <CardMedia
              component="img"
              image="/assets/thumbnail_image001.jpg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
              alt="Team collaborating on recruitment strategy"
              sx={{ 
                width: '100%',
                height: 'auto',
                maxHeight: { xs: '300px', md: '400px' },
                objectFit: 'cover'
              }}
            />
          </Paper>
        </Box>
        
        <Typography 
          variant="subtitle1" 
          align="justify" 
          sx={{ whiteSpace: 'pre-line', mb: 6, maxWidth: '800px', mx: 'auto', fontWeight: 700 }}
        >
          At Recruitment Intelligence, we're not just keeping up with the future of hiring—we're helping to build it - here's our story:
        </Typography> 
        
        <Typography 
          variant="subtitle1" 
          align="justify" 
          sx={{ whiteSpace: 'pre-line', mb: 6, maxWidth: '800px', mx: 'auto' }}
        >
          The idea started with a simple but powerful idea: recruitment needs to evolve. After 40 years leading a top Forbes-ranked executive search and professional recruitment firm, we saw firsthand how companies were struggling to keep up with the growing complexity of hiring today. Traditional staffing methods weren't enough anymore. Employers needed faster access to better data, deeper insight into talent trends, and tools that could keep pace with a rapidly changing world.
        </Typography> 
        
        <Typography 
          variant="subtitle1" 
          align="justify" 
          sx={{ whiteSpace: 'pre-line', mb: 6, maxWidth: '800px', mx: 'auto' }}
        >
          So, we created our own Recruitment Intelligence Consultant, (RiC), the most advanced Ai based recruiter on the market, not just as a platform, but as a smarter, more strategic way to hire.      
        </Typography> 
        
        <Typography 
          variant="subtitle1" 
          align="justify" 
          sx={{ whiteSpace: 'pre-line', mb: 6, maxWidth: '800px', mx: 'auto' }}
        >
          Today, our technology empowers companies to tap into the entire talent market of over 1 billion candidate profiles, spanning both active and passive job seekers. With RiC, you're never limited to just who's looking. You're finding the best people for your role.  
        </Typography> 
        
        <Typography 
          variant="subtitle1" 
          align="justify" 
          sx={{ whiteSpace: 'pre-line', mb: 6, maxWidth: '800px', mx: 'auto' }}
        >
          But technology alone isn't enough. We believe in blending smart tech with expertise. That's why our platform is backed by a team of seasoned recruiters who know how to guide a search with precision, insight, and a human touch. When your hiring needs are critical, Recruitment Intelligence is here to offer experienced support with a smile.  
        </Typography> 
        
        <Typography 
          variant="subtitle1" 
          align="justify" 
          sx={{ whiteSpace: 'pre-line', mb: 6, maxWidth: '800px', mx: 'auto' }}
        >
          We've also built one of the broadest job distribution networks in the industry, getting your roles in front of the right eyes on up to 75 of the world's top job boards. Because visibility matters, but relevance matters even more.  
        </Typography>
        
        <Typography 
          variant="subtitle1" 
          align="justify" 
          sx={{ whiteSpace: 'pre-line', mb: 6, maxWidth: '800px', mx: 'auto' }}
        >
          At the end of the day, we built RIC to be the kind of solution we would want to use: one that's fast, data-driven, intuitive, and always backed by real expertise. Whether you're hiring a key executive, scaling a team, or rethinking your entire talent strategy, we're here to help you do it smarter, faster and for far less than traditional recruitment methods of yesteryear.  
        </Typography>  
        
        <Typography variant="body2" align="center" sx={{ mt: 2, color: 'text.secondary' }}>
          If you need more info or would like to schedule a demo, email us at <Box component="span" sx={{ color: 'primary.main' }}>info@recruitmentintelligence.com</Box>
        </Typography>
      </Container>
    </Box>
  );
};

export default AboutUsPage;